/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SimpleButton from '@lb/components/Buttons/SimpleButton';

/**
 *
 * @param {object} sectionContent
 * @returns
 */

const PromotionalBanner = ({
  sectionContent,
  region,
  language,
  mb,
  pType,
  section,
}) => {
  let isMAPage = section?.sectionId === 'mahalaya-amavasya-agni-pranam'
  let taLang = language === 'ta'

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const bgStyle = {
    red: 'linear-gradient(90deg, rgba(87, 8, 8, 0.8) 43.83%, rgba(188, 64, 52, 0) 91.62%)',
    green:
      'linear-gradient(90deg, rgba(31, 67, 35, 0.8) 43.83%, rgba(54, 100, 59, 0) 91.62%)',
    yellow:
      'linear-gradient(90deg, rgba(158, 103, 20, 0.6) 36%, rgba(217, 217, 217, 0) 91.62%)',
    orange: 
    'linear-gradient(90deg, rgba(158, 103, 20, 0.62) 36%, rgba(217, 217, 217, 0) 91.62%)'
  };

  return sectionContent ? (
    <Box
      h={{
        base: pType == 'home' && section.viewH ? '100svh' : 'auto',
        md: pType == 'home' ? '100vh' : 'auto',
      }}
      maxW={pType == 'home' ? '100%' : '1330px'}
      m="0 auto"
      position="relative"
      mb={isMAPage ? {base: '4rem', md: '5rem', xl: '4rem'} : undefined}
    >
      <LazyLoadImageComponent
        src={
          isMobile
            ? sectionContent?.mobileImage?.url
            : sectionContent?.desktopImage?.url
        }
        w="100%"
        objectFit={isMAPage ? {base: 'cover', xl: 'contain'} : "cover"}
        h={{
          base: pType == 'home' && section.viewH ? '100svh' : '660px',
          md: pType == 'home' ? '100vh' : '650px',
        }}
      />
      <Box
        position="absolute"
        top={0}
        bottom={{ base: taLang ? '50px' : '0px', md: '0' }}
        left="0"
        right={{ base: '0', md: '30%' }}
        display="flex"
        alignItems={{ base: 'flex-end', md: 'center' }}
      >
        <Box
          w="100%"
          h={isMAPage ? {base: '400px', md: 'auto'} : "auto"}
          mb={isMAPage ? {base: '-1.5rem', md: '0px'} : undefined}
          padding={{ base: isMAPage ? '0px' : '21px 0 0', md: '86px 45px', lg: isMAPage ? '20px 105px 0px' : '86px 105px' }}
          display="flex"
          flexDir="column"
          alignContent="flex-start"
          alignItems="flex-start"
          justifyContent="space-between"
          bg={isMAPage ? undefined : {
            md: `${bgStyle[sectionContent?.style]}`,
            base: `${bgStyle[sectionContent?.style]}`,
          }}
          bgGradient={isMAPage ? {
            md: `${bgStyle[sectionContent?.style]}`,
            base: `${bgStyle[sectionContent?.style]}`,
          } : undefined}
          mt={isMAPage ? {base:'0px', xl:'4rem'} : undefined}
        >
          <Box padding={{ base: isMAPage ? '20px 20px' : '40px 20px', md: '0' }} w="100%" h="100%">
            <Box
              pl={{
                base: '0rem',
                md:
                  pType == 'home' ? 'calc( 30vw - 19rem)' : 'calc( 1vw - 9rem)',
              }}
            >
              <Text
                color={isMAPage ? '#F3F0E6' : "title.light"}
                fontFamily={isMAPage ? (taLang ? 'MuktaMalar' : 'FedraSerifDisplay-CondSemiBold') : "FedraSerifDisplay"}
                as="h4"
                fontSize={isMAPage ? {base: '32px', md: '52px'} : { base: '32px', md: 'h4' }}
                lineHeight={{ base: '34px', md: '55.64px' }}
                fontWeight="600"
                mb={{ base: '14px', md: '16px' }}
              >
                {sectionContent?.title}
              </Text>
              {sectionContent?.subtext ? 
              <Text
                color="title.light"
                fontSize={{ base: '18px', md: '26px' }}
                lineHeight={{ base: '19px', md: '31px' }}
                fontWeight="350"
                textTransform="uppercase"
                style={{ fontFeatureSettings: 'case on' }}
                mb={{ base: '13px', md: '12px' }}
              >
                {sectionContent?.subtext}
              </Text> : null}
              <Box
                fontFamily={taLang ? 'MuktaMalar' : undefined}
                color={isMAPage ? '#F8F8F8' : "bodyText.color3"}
                fontSize={{ base: '16px', md: '20px' }}
                lineHeight={isMAPage ? {base: '134%', md: '160%'} : { base: '22px', md: '32px' }}
                fontWeight="350"
                fontStyle="normal"
                mb={isMAPage ? {base: '20px', md: '32px'} : { base: '42px', md: '32px' }}
                maxW={isMAPage ? {base: '306px', md: '490px'} : { sm: '392px', lg: '580px' }}
                h="auto"
              >
                {parser(render(sectionContent?.description))}
              </Box>
              
              {isMAPage ?              
              <SimpleButton
              fontFamily={taLang ? 'MuktaMalar' : undefined}
                mb={mb || '0'}
                mt="0"
                ml={{base: '20px', md: '0px'}}
                style={{
                  buttonStyle: 'LB-Default',
                  buttonText: sectionContent?.ctaLabel,
                  linkUrl: sectionContent?.ctaLink,
                }}
                region={region}
                lang={language}
                bg={"#BC4034"}
                borderLeft={'12px solid #F6A15E'}
                color={"#fff"}
                width={{base: '323px', md: 'auto'}}
                fontSize={{base: '15px', md: '21.89px'}}
                fontWeight={500}
              />
              : 
              <SimpleButton
                mb={mb || '0'}
                mt="0"
                style={{
                  buttonStyle: 'LB-Default',
                  buttonText: sectionContent?.ctaLabel,
                  linkUrl: sectionContent?.ctaLink,
                }}
                region={region}
                lang={language}
              />}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default PromotionalBanner;
